<template>

  <!-- footer_area -->
  <footer id="footer" class="footerArea">

    <div class="inner">
      <ul class="bi">
        <li class="img"><img src="/statics/img/bi.png"></li>
        <li><p>BLUFF &amp; CATCH</p></li>
        <li class="copy">©{{currentYear}} Bluff&amp;Catch All Rights Reserved.</li>
        <!--<li class="copy">BlankHill Entertainment Inc.<br>©2026 Bluff&amp;Catch All Rights Reserved.</li>-->
        <!--<li class="lang">
          <a href="javascript:" title="ENGLISH"><img src="/statics/img/footer_eng.png"></a>
          <a href="javascript:" @click="gotoSite('KR')" title="KOREAN"><img src="/statics/img/footer_kor.png"></a>
          <a href="javascript:" @click="toggleFaqDialog(true);" title="FAQ"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37073/tips_1727348979696.png"></a>
          <a href="javascript:" @click="gotoSite('JP')" title="JAPANESE"><img src="/statics/img/footer_jpn.png"></a>
          <a href="javascript:" @click="toggleTeamDialog(true);" title="TEAM"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37072/tips_1727348873594.png"></a>
          <span class="empty" title="TBD"></span>
        </li>-->
      </ul>
      <ul class="company">
        <li class="about"><p>ABOUT US</p>Bluff&amp;Catch is a specialized content media for poker in the Asia-Pacific market. We provide coverage of major poker tournaments and industry news.</li>
        <li class="about">South Korea | Japan | Vietnam | Thailand | Taiwan | Singapore | Philippines | Malaysia | India | China | Cambodia | Australia</li>
        <li>
          <!--<a @click="toggleFooter1Dialog(true);">Terms of Use</a>
          <a @click="toggleFooter2Dialog(true);">콘텐츠보호안내</a>-->
          <a @click="toggleFooter3Dialog(true);">Cookie Policy</a>
        </li>
        <li class="channel_ctnr">
          <p>OFFICIAL CHANNEL</p>
          <a class="channel" href="https://www.instagram.com/bluffandcatch/" target="_blank"><img src="/statics/img/ftr_insta.png" title="instagram"></a>
          <a class="channel" href="https://t.me/bluffcatch_en" target="_blank"><img src="/statics/img/ftr_tele.png" title="telegram"></a>
          <a class="channel" href="https://www.facebook.com/BluffCatch/" target="_blank"><img src="/statics/img/ftr_fb.png" title="facebook"></a>
        </li>
      </ul>
      <ul class="etc">
        <li><p>CAREER</p>We’re always looking for members to join our team.<br>Wanted: Content Marketer, Web Designer, Guest Journalist<br>Apply : allin@bluffcatch.com</li>
        <li><p>CONTACT US</p>News reports, affiliate/promotion/advertising and other inquiries.<br>E-MAIL : allin@bluffcatch.com<br>Telegram : @bluffcatch</li>
      </ul>
    </div>

    <!-- Faq -->
    <q-dialog v-model="isOpenFaqDialog">
			<div class="modal_faq">
		    <a class="modal_close_btn" @click="toggleFaqDialog(false);">close</a>
		    <h5>FAQ</h5>
		    <div class="contain">
          <ul class="qna">
            <li class="que">I want to change the language of my site.</li>
            <li class="ans">Click the menu (☰) button in the top-right corner of the site -> Change a language on the top left to move the site to each language.(Located at the top right and bottom left for PC connection)<br>Bluff&amp;Catch is available in three languages: English, Korean, and Japanese.</li>
            <li class="que">Why do the three language sites have slightly different content and organization?</li>
            <li class="ans">Bluff&amp;Catch maintains three separate sites in three languages to cater to its Asia-Pacific audience. The same article may have slightly different content, and articles and content can be customized for site users in each language.</li>
            <li class="que">Does Bluff&amp;Catch work for a specific brand or online gaming company?</li>
            <li class="ans">No. Bluff&amp;Catch is an <b>INDEPENDENT</b> media outlet that is not affiliated with any particular company/game. We have various types of partnerships with brands to produce article content, banner ads, and on-site coverage.</li>
            <li class="que">What types of partnerships are available with Bluff&amp;Catch?</li>
            <li class="ans">We are open to discussing any type of partnership. It can take the form of field reporting and article production, as well as customized live reporting and galleries (photo partnerships), and we can customize the proposal to meet the needs of our partners. For more information, please contact by e-mail allin@bluffcatch.com/lime@bluffcatch.com</li>
          </ul>
        </div>
		  </div>
		</q-dialog>

   <!-- Team -->
    <q-dialog v-model="isOpenTeamDialog">
			<div class="modal_team">
		    <a class="modal_close_btn" @click="toggleTeamDialog(false);">close</a>
		    <h5>TEAM</h5>
		    <div class="contain">
          <ul class="member">
            <li class="name">JAY<span>“BC will be the leading poker media in Asia.”</span></li>
            <li class="contact"><b>Founder/CEO</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37100/tips_ico_insta.png">@jaay.bak</li>
            <li class="desc">I used to think that it would be nice to have a poker media in Korea since many years ago. Cause it was a bit of a negative area in Korea, but it was already thriving in the US and Europe. After Covid-19, the Korean market is growing rapidly, and the Asian market is also growing. At the center of it, Bluff&amp;Catch continues to grow, and we are aiming to become the leading poker media in the Asia-Pacific market. With the best members on board, I think we will be able to achieve this soon. 😉</li>
          </ul>
          <ul class="member">
            <li class="name">JUN<span>“I'd love to connect with everyone in the poker scene.”</span></li>
            <li class="contact"><b>Contents Marketer/Business Strategy</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/36619/tips_ico_tg.png">@BC_Jun</li>
            <li class="desc">As a business alliance representative, I am responsible for key communications with each brand. I also work as a content marketer writing specialized poker content and reporting from the field of major tournaments. Since the people in charge of major brand companies I meet are usually foreigners or have many overseas residents, I often have English mail or Zoom meetings. I often spend more than half of my time abroad a month during the field coverage period. There was a time when I was immersed in poker and the life of a poker player, and then I met BC and became an early member. I'm probably the only person in Korea doing this.</li>
          </ul>
          <ul class="member">
            <li class="name">LOOPY<span>“Let's say hello when we meet at the scene.”</span></li>
            <li class="contact"><b>Contents Marketer</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/36619/tips_ico_tg.png">@loopy_kim</li>
            <li class="desc">I was working as an editor for another brand when Jay suggested I join BC. Two things appealed to me: being able to utilize my major through writing and field reporting, and exploring a new area of poker. Crucially, I was most eager to grow with Bluff&amp;Catch, a brand that has come on leaps and bounds in just one year. I may be the youngest member of the team, but I'm no slouch when it comes to staying on top of poker trends. I'm responsible for writing articles, covering global tournaments, and running social media channels!😎 Greet me when I meet you on the spot~</li>
          </ul>
          <ul class="member">
            <li class="name">LIME<span>“If I can turn even one person into a BC user, that's my goal.”</span></li>
            <li class="contact"><b>Marketer/Operator</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37099/tips_ico_mail.png">lime@bluffcatch.com</li>
            <li class="desc">I’m responsible for the management and operations across each of our sites in three languages, including data and advertising. And I make sure our editors are getting the right exposure for the content they produce, and that I have the ad partnerships and data to back it up. I guess you could say I'm doing all the work to make sure that Bluff&amp;Catch is a media service that works for our users. As I fell in love with poker as a new hobby, I naturally met and joined BC. Personally, I believe that I joined as an unofficial ambassador and member because of my natural(?) playing skills in addition to my professional skills. Am I right? 🤭</li>
          </ul>
          <ul class="member">
            <li class="name">MANNY</li>
            <li class="contact"><b>Co-Founder/Instagram Manager</b><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37100/tips_ico_insta.png">@bluffandcatch</li>
            <!--<li class="desc">Official Instagram representative and Hidden Director</li>-->
          </ul>
        </div>
		  </div>
		</q-dialog>

    <!-- Cookie policy -->
		<q-dialog v-model="isOpenFooter3Dialog">
			<div class="share_pop info_pop">
				<a class="modal_close_btn" @click="toggleFooter3Dialog(false);">close</a>
        <h3>Cookie Notice<br><span>(Bluff&amp;Catch's Use of Cookies)</span></h3>
				<div class="contain">
          <p>Bluff&amp;Catch's website and online services may use "cookies". Cookies allow you to add items to your shopping cart, personalize your experience on the Bluff&amp;Catch website, and let Bluff&amp;Catch know which pages you have visited on our website so that we can measure the effectiveness of our advertising and web searches. This allows Bluff&amp;Catch to measure the efficiency of advertising and web searches. This helps Bluff&amp;Catch to improve its communication, content and products.</p>
          <p>If you do not agree to the use of cookies in your web browser, please select "I do not agree to the use of cookies" from the privacy menu in your browser settings. The method of setting cookies may vary depending on the browser you are using, so please check with each browser for instructions on how to set cookies.</p>
          <p>Cookies are used across all Bluff&amp;Catch sites, so if you do not agree to the use of cookies, you may not be able to use certain parts of the site.</p>
          <p>The cookies used on the Bluff&amp;Catch website are based on the International Chamber of Commerce (ICC) UK Cookie Guide classification. Bluff&amp;Catch uses the following types of cookies for the Bluff&amp;Catch website and other online services</p>
          <h6>1. Mandatory cookies</h6>
          <p>Mandatory cookies are cookies that are essential for you to be able to search the Bluff&amp;Catch website and use the features offered on our site. If you do not agree to the use of cookies, you will not be able to add products to your cart on our site or use services such as e-billing.</p>
          <h6>2. Performance cookies</h6>
          <p>Performance cookies primarily collect information about how you use our site, such as information about the pages you visit. The data collected is used to improve the performance of the Site and to promote the optimization of your use of the Site. Data on access to this site, use of services, shopping history, etc. is shared by our website and our group companies for the purpose of providing services to our customers. Please note that these cookies do not identify any specific individuals. All information collected by performance cookies is aggregated and thus anonymous.</p>
          <h6>3. Functional analysis cookies</h6>
          <p>Functional analysis cookies allow the Bluff&amp;Catch website to remember the choices you make within the site during your visit. For example, geographic locations can be stored in cookies to localize the website to the user's region. It can also remember settings such as text size, fonts, and other customizable site elements. They can also analyze product browsing history and video playback, and use the data to present you with products and videos that match your preferences. These cookies do not identify individual users and it is not possible to track your browsing behavior on other non-Bluff&amp;Catch websites.</p>
				</div>
			</div>
		</q-dialog>
    <!-- 청소년보호정책 //-->

  </footer>
  <!-- //footer_area -->

</template>

<script>
  import { QDialog } from 'quasar'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  export default {
    name: "Footer",
    components: {
      QDialog
    },
    data () {
      return {
        time: '',
      }
    },
    mounted () {
			this.getTime()
    },
    computed: {
      ...CommonComputed,
      isOpenFooter1Dialog: {
        get () {
          return this.$store.getters.isOpenFooter1Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter1Dialog', flag)
        }
      },
      isOpenFooter2Dialog: {
        get () {
          return this.$store.getters.isOpenFooter2Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter2Dialog', flag)
        }
      },
      isOpenFooter3Dialog: {
        get () {
          return this.$store.getters.isOpenFooter3Dialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFooter3Dialog', flag)
        }
      },
      isOpenFaqDialog: {
        get () {
          return this.$store.getters.isOpenFaqDialog
        },
        set (flag) {
          this.$store.dispatch('setOpenFaqDialog', flag)
        }
      },
      isOpenTeamDialog: {
        get () {
          return this.$store.getters.isOpenTeamDialog
        },
        set (flag) {
          this.$store.dispatch('setOpenTeamDialog', flag)
        }
      },
      currentYear () {
        return new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' })
        ).getFullYear()
      }
    },
    methods: {
      ...CommonMethods,
      toggleFooter1Dialog (flag) {
        this.$store.dispatch('setOpenFooter1Dialog', flag)
      },
      toggleFooter2Dialog (flag) {
        this.$store.dispatch('setOpenFooter2Dialog', flag)
      },
      toggleFooter3Dialog (flag) {
        this.$store.dispatch('setOpenFooter3Dialog', flag)
      },
      toggleFaqDialog (flag) {
        this.$store.dispatch('setOpenFaqDialog', flag)
      },
      toggleTeamDialog (flag) {
        this.$store.dispatch('setOpenTeamDialog', flag)
      },
      getTime() {
				setInterval( () => {
          var today = new Date();
          var year = today.getFullYear();
          var month = ((today.getMonth() + 1));
          var day = (today.getDate());
//          var month = ('0' + (today.getMonth() + 1)).slice(-2);
//          var day = ('0' + today.getDate()).slice(-2);
          this.time = year + '년 ' + month + '월 ' + day + '일';
				}, 1000);
			},
    }
  }
</script>

<style scoped>
  .footerArea {
    min-width: 1270px;
    text-align: center;
    margin: 0 auto;
  }
  .footerArea .inner {
    width: 1220px;
    border-top: 2px solid #000;
    padding: 50px 0;
  }
  .footerArea .inner ul {
    display: inline-block;
    width: 33.333%;
    padding: 0 38px;
  }
  .footerArea .inner ul:last-child {
    border-right: 0;
  }
  .footerArea .inner ul.company {
    border-left: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
  }
  .footerArea .inner ul li:last-child {
    margin-bottom: 0;
  }
  .footerArea .inner li {
    font-size: 13.5px;
    font-weight: 400;
    color: #666;
    letter-spacing: -0.01em;
    line-height: 1.8em;
    text-align: left;
    margin-bottom: 25px;
  }
  .footerArea .inner li i {
    color: #bbb;
  }
  .footerArea .inner li p {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    margin-bottom: 5px;
  }
  .footerArea .inner li a {
    color: #008c03;
  }
  .footerArea .inner li a:hover {
    text-decoration: underline;
  }
  .footerArea .inner .bi p:after {
    content: "™";
    position: absolute;
  }
  .footerArea .inner .bi li {
    text-align: center;
  }
  .footerArea .inner .bi .img {
    margin-bottom: 10px;
  }
  .footerArea .lang {

  }
  .footerArea .lang a {
    display: inline-block;
    margin: 5px;
    position: relative;
    width: 45px;
    height: 60px;
  }
  .footerArea .lang a:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.25);
    border-radius: 0.3em;
    z-index: 1;
  }
  .footerArea .lang img {
    max-width: 100%;
    max-height: 100%;
  }
  .footerArea .lang .current:after {
    border: 1px solid rgba(0,0,0,1.0);
  }
  .footerArea .lang .current img {
    opacity: 1.0;
  }
  .footerArea .lang .empty {
    position: relative;
    display: inline-block;
    margin: 5px;
    width: 45px;
    height: 60px;
    background-image: url(/statics/img/bi.png);
    background-color: #fff;
    background-size: 60%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border-radius: 0.3em;
    isolation: isolate;
  }
  .footerArea .lang .empty:after {
    content: "";
    position: absolute;
    background: #ddd;
    inset: 0;
    opacity: 0.75;
    border-radius: 0.3em;
    border: 1px dashed rgba(0,0,0,0.25);
  }
  .footerArea .inner .company li.about {
    margin-bottom: 10px;
  }
  .footerArea .inner .company li a {
    display: inline-block;
    color: #777;
    font-weight: 700;
    cursor: pointer;
  }
  .footerArea .inner .company li a:hover {
    color: #008c03;
  }
  .footerArea .inner .company li a.channel {
    display: inline-block;
    padding: 10px 10px 0 10px;
  }
  .footerArea .inner .company li a.channel:nth-child(2) {
    padding-left: 0;
  }
  .footerArea .inner .company li a.channel img {
    height: 32px;
  }

  .share_pop {
    position: relative;
    background: #fff;
  }
  .share_pop .close_btn {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    font-size: 0;
    text-indent: -9999px;
    background: url(/statics/img/close_01.png);
		background-size: 100%;
		z-index: 1;
  }
	.share_pop ul li {
		position: relative;
		font-size: 12px;
		text-align: center;
		display: inline-block;
		width: 25%;
		margin-bottom: 20px;
		cursor: pointer;
	}
  .q-dialog__inner .info_pop {
    width: 50vw;
    height: calc(100% - 80px);
    max-width: unset;
    max-height: unset;
		padding: 80px 0 0;
    overflow-y: hidden;
	}
	.info_pop h3 {
    position: absolute;
    top: 18px;
		width: 100%;
    font-size: 18px;
		font-weight: 800;
		text-align: center;
    line-height: 1.20em;
	}
  .info_pop h3 span {
		font-size: 0.8em;
    font-weight: 600;
	}
	.info_pop .close_btn {
		position: absolute;
		right: 12px;
		top: 12px;
		cursor: pointer;
		width: 20px;
		height: 20px;
		font-size: 0;
		text-indent: -9999px;
		background: url(/statics/img/close_01.png);
		background-size: 100%;
		z-index: 1;
	}
	.info_pop .contain {
		width: 100%;
    height: 100%;
    padding: 0 20px 20px;
    overflow-y: scroll;
    font-size: 14px;
    font-weight: 400;
    color: #777;
    line-height: 1.7em;
	}
	.info_pop .contain h6 {
		font-size: 15px;
		font-weight: 600;
    color: #000;
		letter-spacing: -0.01em;
		margin: 15px 0 10px;
		line-height: 1.6em;
	}
	.info_pop .contain p {
		margin: 4px 0 10px;
	}
	.info_pop .contain ol li {
		list-style: decimal;
    margin-left: 18px;
    margin-bottom: 6px;
	}
	.info_pop .contain ol li:last-child {
    margin-bottom: 18px;
	}
	.info_pop .contain ul li {
		list-style-type: "-";
    margin-left: 18px;
    margin-bottom: 6px;
	}
	.info_pop .contain ul li:last-child {
    margin-bottom: 18px;
	}
  .info_pop.contents {
    width: auto !important;
		height: auto !important;
	}
  .info_pop.contents h3 {
    width: 100% !important;
	}
  .info_pop.contents .contain {
    overflow: hidden;
    padding: 0 20px 20px;
	}
  .info_pop.teen {
    height: auto;
	}
  .layerBackdrop > div {
    position: relative;
    padding: 15px;
  }
  /deep/ .layerBackdrop a > img {
    max-width: 320px !important;
  }
	/* on wallpaper */
	.wallpaper .footerArea {
   background: #fff;
  }
  .modal_close_btn {
		position: absolute;
		right: 12px;
		top: 12px;
		cursor: pointer;
		width: 40px;
		height: 40px;
		font-size: 0;
		text-indent: -9999px;
		background: url(/statics/img/close_01.png) no-repeat;
		background-size: 50%;
    background-position: center;
		z-index: 1;
	}
	.modal_close_btn:hover:before {
		content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: inline-block;
    width: 40px;
    height: 40px;
    background: rgba(0,0,0,0.05);
    border-radius: 100%;
	}

   /* FAQ Modal */
  .modal_faq {
    position: relative;
    max-width: unset;
    width: 680px;
    height: auto;
    background: #fff;
    border-radius: 5px;
    padding-top: 80px;
  }
  .modal_faq h5 {
    display: flex;
    width: 100%;
    height: 80px;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.03em;
    position: absolute;
    top: 0;
    left: 0;
  }
  .modal_faq .contain {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0 30px 30px;
  }
  .modal_faq ul.qna li {
    font-size: 14px;
    font-weight: 400;
    color: #777;
    line-height: 1.6em;
    padding-left: 25px;
    position: relative;
  }
  .modal_faq ul.qna li.ans:last-child {
    margin-bottom: 10px;
  }
  .modal_faq ul.qna li.que {
    font-size: 15px;
    font-weight: 600;
    color: #222;
    margin-bottom: 8px;
  }
  .modal_faq ul.qna li.que:before {
    content: "Q.";
    position: absolute;
    font-weight: 700;
    color: #000;
    left: 0;
  }
  .modal_faq ul.qna li.ans {
    border-radius: 12px;
    margin-bottom: 22px;
  }
  .modal_faq ul.qna li.ans b {
    font-weight: 600;
  }
  .modal_faq ul.qna li.ans:before {
    content: "A.";
    position: absolute;
    font-size: 15px;
    font-weight: 700;
    color: #00b30a;
    left: 0;
  }

  /* Team Modal */
  .modal_team {
    position: relative;
    max-width: unset;
    width: 680px;
    height: calc(100% - 80px);
    background: #fff;
    border-radius: 5px;
    padding-top: 80px;
  }
  .modal_team h5 {
    display: flex;
    width: 100%;
    height: 80px;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.03em;
    position: absolute;
    top: 0;
    left: 0;
  }
  .modal_team .contain {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 0 30px 30px;
  }
  .modal_team ul {
    background: #f9f9f9;
    padding: 25px;
    border-radius: 6px;
    margin-bottom: 15px;
  }
  .modal_team ul:last-child {
    margin-bottom: 0;
  }
  .modal_team ul:last-child .contact {
    margin-bottom: 0;
  }
  .modal_team ul li {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 1.0em;
    position: relative;
  }
  .modal_team ul li.name {
    font-size: 18px;
    font-weight: 700;
    color: #222;
    letter-spacing: -0.03em;
    line-height: 1.0em;
  }
  .modal_team ul li.name span {
    font-size: 16px;
    font-weight: 400;
    color: #888;
    margin-left: 10px;
  }
  .modal_team ul li.contact {
    font-size: 13.5px;
    color: #222;
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 16px;
  }
  .modal_team ul li.contact h6 {
    font-size: 18px;
    font-weight: 700;
    color: #222;
    letter-spacing: -0.03em;
    line-height: 1.0em;
  }
  .modal_team ul li.contact b {
    font-weight: 500;
  }
  .modal_team ul li.contact img {
    width: 16px;
    margin: 0 4px 0 8px;
  }
  .modal_team ul li.desc {
    line-height: 1.6em;
  }
</style>
